import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-54e1c848")
const _hoisted_1 = {
  key: 0,
  class: "sing-play"
}
const _hoisted_2 = {
  key: 1,
  class: "sing-play-not-render"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "教材曲谱加载中...", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 2,
  class: "sing-play-not-render"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, "教材曲谱渲染失败", -1)
const _hoisted_7 = [
  _hoisted_6
]
_popScopeId()

import { onMounted, ref } from 'vue'
import SheetMusicSong from '@evideo/design-vue/lib/sheet-music-song'
import { message } from 'ant-design-vue'
import { toCameCaseObj } from '@/utils/common'
import '@evideo/design-vue/lib/sheet-music-song/style'

declare global {
  interface Window {
    SheetMusic: any;
    SheetMusicBusiness: any;
    SVG: any;
    Display: any;
    initSheetLib: any;
  }
}


export default /*#__PURE__*/_defineComponent({
  props: {
  data: {
    type: Object,
    required: true
  }
},
  setup(__props) {

const props = __props

const canRenderSingPlay = ref(false)
const loading = ref(true)
const singPlayData = ref({})
const sheetContainer = ref()

const onError = (e: any) => {
  console.warn(e)
  message.error({
    type: 'error',
    message: '曲谱加载失败,请重新加载课件或检查网络',
    offset: 200
  })
}

const onAudioCacheError = ({
  audioCanPlay,
  preFetchAudioOK
}: {
  audioCanPlay: boolean;
  preFetchAudioOK: boolean;
}) => {
  if (!audioCanPlay) {
    message.error({
      type: 'error',
      message: '音频加载失败,请重新加载课件或检查网络',
      offset: 200
    })
    return
  }
  if (!preFetchAudioOK) {
    message.error({
      type: 'error',
      message: '音频正在加载，请稍后尝试',
      offset: 200
    })
  }
}

const initSingPlayData = () => {
  const data = toCameCaseObj(props.data || {})
  // 默认播放模式为范唱，无音频则伴唱，无则曲谱模式
  let playMode = 'ori'
  if (!data.oriFileUrl) {
    playMode = 'acc'
  }
  if (playMode === 'acc' && !data.accFileUrl) {
    playMode = 'midi'
  }
  singPlayData.value = {
    loadSheetMode: 'common',
    playMode,
    song: data,
    workerPublicPath: `${process.env.APP_URL}`,
    sheetOption: {
      playerOptions: {
        fluidsynthLibHost: `${process.env.APP_URL}`
      }
    }
  }
}

onMounted(async () => {
  canRenderSingPlay.value = false
  if (!(window.SVG && window.Display && window.SheetMusic?.Note)) {
    try {
      await window.initSheetLib()
    } catch (e) {
      console.error('initSheetLib error', e)
      loading.value = false
      canRenderSingPlay.value = false
      return
    }
  }
  initSingPlayData()
  loading.value = false
  canRenderSingPlay.value = true
})

return (_ctx: any,_cache: any) => {
  return (canRenderSingPlay.value && !loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(SheetMusicSong), _mergeProps({
          ref: (_value, _refs) => {
            _refs['sheetContainer'] = _value
            sheetContainer.value = _value
          }
        }, singPlayData.value, {
          onError: onError,
          onAudioCacheError: onAudioCacheError
        }), null, 16)
      ]))
    : (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
}
}

})